<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M8.9 21H3.5c-.3 0-.5-.2-.5-.5v-17c0-.3.2-.5.5-.5h14.4c.3 0 .5.2.5.5v6.6c0 .5.4 1 1 1s1-.4 1-1V3.5c0-1.4-1.1-2.5-2.5-2.5H3.5C2.1 1 1 2.1 1 3.5v17C1 21.9 2.1 23 3.5 23h5.4c.5 0 1-.4 1-1s-.4-1-1-1zm13.8-6-2-2c-.4-.4-1-.4-1.4 0l-6.6 6.5c-.2.2-.3.4-.3.7V22c0 .6.4 1 1 1h2.3c.3 0 .5-.1.7-.3l6.3-6.3c.2-.2.3-.4.3-.7s-.1-.5-.3-.7zm-7.4 6h-.9v-.5L20 15l.6.6-5.3 5.4z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M9.9 11.1h-4c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v4c0 .5-.5 1-1 1zm-3-2h2v-2h-2v2zm3 9.9h-4c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v4c0 .6-.5 1-1 1zm-3-2h2v-2h-2v2zm8.6-9.9h-2.3c-.6 0-1-.4-1-1s.4-1 1-1h2.3c.6 0 1 .4 1 1s-.4 1-1 1zm0 4h-2.3c-.6 0-1-.4-1-1s.4-1 1-1h2.3c.6 0 1 .4 1 1s-.4 1-1 1zM13.7 15h-.4c-.6 0-1-.4-1-1s.4-1 1-1h.4c.6 0 1 .4 1 1s-.5 1-1 1z" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
